<template>
  <div class="systembody">
    <div style="margin-top: 10px;">
    <div class="sectionLargeIcon largeServerIcon"></div>
    <div class="widget clearfix">
      <span class="title" style="font-size: 22px; margin-right: 15px; font-weight: 600 !important; color: #183677;">
        שיחות און ליין </span>
      <div class="widget_inside" style="margin-top: 15px;">
        <OnLineComp />
      </div>
    </div>
  </div>
  </div>
  </template>
  <script>
  import OnLineComp from '@/components/onLineUsers/OnLineComp'
  import Auth from '@/services/auth.service.js'
  
  export default {
    name: 'upload',
    components: {
      OnLineComp,
    },
    methods: {
      openSelected(itemNum) {
        this.itemSelected = itemNum;
      },
    },
    created() {
      document.title = 'שיחות אונליין | clickcall'
      let auth = Auth.checkAuth();
      if (!auth) {
        this.$router.replace({ name: "login" })
      }
    },
  }
  </script>
  <style scoped>
  
 
  </style>